import { Goal } from './Goal';

import styles from './progressbar-with-goals.module.less';

export function ProgressbarWithGoals({
    className,
    goalClassName,
    goals,
    moneygoal,
    collectedAmountWithoutMatching,
    matchingCollectedAmount,
}) {
    const projectGoals = goals ? [...goals] : [];

    projectGoals.push({
        amount: moneygoal,
        id: 'moneygoal',
    });

    projectGoals.sort((a, b) => a.amount - b.amount);

    const mappedGoals = projectGoals.map((projectGoal, index, array) => {
        return {
            ...projectGoal,
            startAmount: index === 0 ? 0 : array[index - 1].amount,
        };
    });

    const maxGoal = mappedGoals[mappedGoals.length - 1].amount;
    const totalCollected = collectedAmountWithoutMatching + matchingCollectedAmount;

    // this is to ensure that each bar never takes more than 50% of the total bar width
    // (makes sure that the calculations in each goal is correct)
    if (totalCollected > maxGoal) {
        // we need to rescale collectedAmountWithoutMatching and matchingCollectedAmount to sum to maxGoal
        // we do this by multiplying each amount by maxGoal / totalCollected
        const rescaleFactor = maxGoal / totalCollected;
        collectedAmountWithoutMatching *= rescaleFactor;
        matchingCollectedAmount *= rescaleFactor;
    }

    return (
        <div className={[styles.progressBarContainer, className].join(' ')}>
            {mappedGoals.map((goal, index) => (
                <Goal
                    className={goalClassName}
                    key={goal.id}
                    index={index}
                    originalGoal={moneygoal}
                    maxGoal={maxGoal}
                    goal={goal}
                    collectedByGivers={collectedAmountWithoutMatching}
                    matchingAmount={matchingCollectedAmount}
                />
            ))}
        </div>
    );
}
